import { render, staticRenderFns } from "./template.html?vue&type=template&id=a0529404&scoped=true&"
import script from "./HomeFavoritelist.vue?vue&type=script&lang=ts&"
export * from "./HomeFavoritelist.vue?vue&type=script&lang=ts&"
import style0 from "./HomeFavoritelist.vue?vue&type=style&index=0&id=a0529404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0529404",
  null
  
)

export default component.exports